export const I18n = {
    'en': {

    },
    'ru': {
        redirects: 'Перенаправления',
        companyTitle: 'Компания',
        app: 'Приложение',
        title: 'Название',
        offerTitle: 'Название оффера',
        company: 'Сеть',
        salesPoint: 'Торговая точка',
        user: 'Пользователь',
        device: 'Устройство',
        dateTime: 'Дата и время',
        installs: 'Установки',
        sales: 'Продажи',
        summ: 'Сумма',
        status: 'Статус',
        time: 'Время',
        dateFrom: 'C даты',
        dateTo: 'По дату',
        filter: 'Применить фильтры',
        resetFilter: "Сбросить фильтры",
        download: 'Выгрузить в CSV',
        offerDevStatTitle: 'Оффера',
        byCampanyTitle: 'По кампаниям',
        all: 'Все',

    },
    'sk': {

    }
};



// WEBPACK FOOTER //
// ./src/I18n/components/Promo/PromoSummaryStat/index.js